import React, {useState, useEffect, useContext} from "react";
import BasicView from "../../components/BasicView";
import {isMobile} from "../../constants/Helpers";
import {SecondView} from "../../styles/HeadView";
import styled from "styled-components";
import HeadsVies from "../../styles/HeadsVies";
import {useParams} from "react-router-dom";
import parse from "html-react-parser";
import {FacilitatorsContext} from "../../context/FacilitatorsContext";
import {LoadComponet} from "../../components/loaders/Loader";

export default function FacilitadorDetail() {
   const {getOnlyOne, currentFacilitator} = useContext(FacilitatorsContext);
   const [data, setData] = useState({});
   const {id} = useParams();

   useEffect(() => {
      getOnlyOne(id);
   }, [id]);

   useEffect(() => {
      let nameF = currentFacilitator.facilitatorName + " " + currentFacilitator.facilitatorLastName;
      let nTitle = nameF ? nameF + " - Domecq Academy" : "Domecq Academy";
      document.title = nTitle;
      return () => {
         document.title = "Domecq Academy";
      };
   }, [id, currentFacilitator]);

   if (currentFacilitator.isLoading) return <LoadComponet />;
   // if (currentFacilitator === null) return null;
   return (
      <BasicView
         borderNone={true}
         imageBack={`http://domecqapi.trebolbit.com/${
            isMobile ? currentFacilitator.pathImageBioMobile : currentFacilitator.pathImageBioDesktop
         }`}
         paddingHead="3em 0 0 0"
         isSecondary={true}
      >
         <HeadsVies
            description={currentFacilitator.biography || "No hay una descripción disponible"}
            title={`${currentFacilitator.facilitatorName} ${currentFacilitator.facilitatorLastName}`}
            subtitle={currentFacilitator.shortDescription}
            type="Facilitators"
         />
         <></>
      </BasicView>
   );
}
//  description, title, icon
